import React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../../components";
import * as Forms from "../../../../forms";

interface OwnProps {
    contentBlockId: number;
    formComponent: Comp.Validation.IComponentWithValidatedForm;
    label?: string;
    namePrefix: string;
    onSlideAdd: (contentBlockId: number) => void;
    onSlideDelete: (contentBlockId: number, slideIdx: number) => void;
    slides: Forms.AdminPage.ContentCarouselSlideData[];
}

interface OwnState {
    showSlides: boolean[];
}

export type ContentCarouselMoveDir = -1 | 0 | 1 | 2;

export class ContentCarouselEditor extends React.Component<OwnProps, OwnState> {

    private _collapseTimeout: number = 175;

    public constructor(props: any) {
        super(props);
        this.state = {
            showSlides: [],
        };
    }

    public componentDidMount() {
        const showSlides = this.props.slides.map((s) => (s.id !== 0 && !s.delete));
        this.setState({ ...this.state, showSlides });
    }

    public componentWillReceiveProps(nextProps: OwnProps) {
        // hide newly added (for fade effect)...
        let showSlides = nextProps.slides.map((s) => (s.id !== 0 && !s.delete));
        this.setState({ ...this.state, showSlides }, () => {
            // ...and show all except deleted
            showSlides = nextProps.slides.map((s) => (!s.delete));
            this.setState({ ...this.state, showSlides });
        });
    }

    public render() {
        const label = this.props.label
            ? <Comp.Editors.FormField name=""><hr /><h2>{this.props.label}</h2></Comp.Editors.FormField>
            : null;

        let slideNum = 0;
        const slides = this.props.slides.map((s, i) => {
            if (!s.delete)
                slideNum++;

            const show = this.state.showSlides.length > i
                ? this.state.showSlides[i]
                : false;
            const idx = s.index;
            // const cbId = this.props.contentBlockId;
            const sequencer = <div>
                <div>{`Slide #${slideNum}`}</div>
                <BS.ButtonGroup className="btn-group-vertical">
                    <BS.Button bsStyle="danger" onClick={() => this.handleSlideDelete(i)} title="Delete slide"><i className="fa fa-times"></i></BS.Button>
                </BS.ButtonGroup>
            </div>;

            return <BS.Collapse key={i} in={!s.delete && show} onExited={() => this.onSlideDeleted(idx)} timeout={this._collapseTimeout}>
                    <div className="carousel-editor-slide">
                        <Comp.Editors.FormField labelChildren={sequencer} name="">
                            <Comp.Editors.NumberField
                                formComponent={this.props.formComponent}
                                description={<strong>Sequence</strong>}
                                name={this.props.namePrefix + `slides[${idx}].sort`}
                                noFieldWrap
                                required={false}
                            />

                            <Comp.Editors.TextField
                                formComponent={this.props.formComponent}
                                description={<strong>Image</strong>}
                                name={this.props.namePrefix + `slides[${idx}].image`}
                                noFieldWrap
                                required={false}
                            />

                            <Comp.Editors.RichTextField
                                formComponent={this.props.formComponent}
                                description={<strong>Description</strong>}
                                name={this.props.namePrefix + `slides[${idx}].description`}
                                noFieldWrap
                                options={{
                                    height: 100,
                                    width: "59.8%",
                                }}
                            />
                        </Comp.Editors.FormField>
                    </div>
                </BS.Collapse>;
        });

        return <div className="content-block-editor">
            {label}
            <Comp.Editors.NumberField formComponent={this.props.formComponent} name={this.props.namePrefix + "slideSpeed"} />

            {slides}

            <Comp.Editors.FormField name="">
                <BS.Button onClick={() => this.props.onSlideAdd(this.props.contentBlockId)}><i className="fa fa-plus"></i> Add slide</BS.Button>
            </Comp.Editors.FormField>
        </div>;
    }

    private handleSlideDelete(slideIdx: number) {
        const showSlides = [...this.state.showSlides];
        if (showSlides.length > slideIdx) {
            showSlides[slideIdx] = false;
            this.setState({ ...this.state, showSlides });
        }
    }

    private onSlideDeleted(slideIdx: number) {
        this.props.onSlideDelete(this.props.contentBlockId, slideIdx);
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminPage/edit/editors/ContentCarouselEditor.tsx